import RoutesCreerCompteEtape1 from './etape-1/routes';
import RoutesCreerCompteEtape2 from './etape-2/routes';
import GuideCreerCompte from './aide/routes';
import { initSubRoutes } from '../../../utils/router';

const RoutesCreerCompte = initSubRoutes({
    route: '/creer',
    subroutes: {
        etape1: RoutesCreerCompteEtape1,
        etape2: RoutesCreerCompteEtape2,
        aide: GuideCreerCompte,
    },
    nom: 'Création de compte',
});

export default RoutesCreerCompte;
